import React from 'react';
import { TextBackgroundPhoto } from '@components/TextBackgroundPhoto';
import { Box } from '@components/Box';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { UnlockIconSVG, MainTextPairing, ControlContainer } from './PlusOneControls.styles';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { useTranslation } from 'react-i18next';

export const PlusOneControls: React.FC<{}> = () => {
  const sectionId = 'Unlock_Plus_Ones';
  const isMobileDevice = useThemeMediaQuery('below_sm');
  const { t } = useTranslation('onlineRsvp');
  const unlockedPlusOnes = t('unlockedPlusOnes');
  return (
    <Box id={sectionId}>
      <TextBackgroundPhoto zoom={true} src={cloudAssetUrl('wedding-invitations/plus-one-controls/large-venue_bg.jpg')} textCentered={true}>
        <ControlContainer>
          <UnlockIconSVG alt="unlock_icon" src="wedding-invitations/plus-one-controls/icon_lock-unlocked.svg" />
          <MainTextPairing
            alignment={'center'}
            title={unlockedPlusOnes.title}
            titleVariant={isMobileDevice ? 'calloutHed32' : 'calloutHed40'}
            titleColor={'blue6'}
            titleTagName="h2"
            body={unlockedPlusOnes.body}
            bodyColor={'blue6'}
            bodyVariant={isMobileDevice ? 'dek24' : 'calloutDek40'}
            bodyTagName="h2"
          />
        </ControlContainer>
      </TextBackgroundPhoto>
    </Box>
  );
};
